import { FunctionComponent, ReactElement } from 'react'
import poweredByLedger from '@assets/images/home/logoLegerPixelNoir.jpg'
import { useTranslation } from 'react-i18next'
import { isCanadaApp, isQuebecApp, isUSAApp } from '@models/AppType'

import './PoweredBy.scss'

export const PoweredBy: FunctionComponent = (): ReactElement => {
  const { t } = useTranslation('Home')

  const renderPoweredBy = () => {
    if (isUSAApp || isCanadaApp || isQuebecApp) {
      return (
        <a className="Propulsed-MultipleImage" href={t('propulsedUrl')} target="_blank">
          {t('propulsed')}
          <img className="Propulsed-MultipleImage-CompanyImage" src={poweredByLedger} alt={t('propulsedBy')} />
        </a>
      )
    }
  }

  return <div className="Propulsed">{renderPoweredBy()}</div>
}
